/**
 * Keeps the browser's context menu off the game page while preserving it on fields that take text, so right click
 * remains available to the game without taking paste away from chat and account forms (R-0059).
 *
 * @param target The game page event target.
 * @param isTextField Whether an event target is a shown field that takes text.
 * @returns A function that restores the page's normal context-menu behavior.
 */
export function suppressGameContextMenu(target: EventTarget, isTextField: (target: unknown) => boolean): () => void {
  /**
   * Prevents a context menu unless the press is over a text field.
   *
   * @param event The context-menu request.
   */
  const onContextMenu = (event: Event): void => {
    if (!isTextField(event.target)) {
      event.preventDefault();
    }
  };
  target.addEventListener("contextmenu", onContextMenu, { capture: true });
  return () => target.removeEventListener("contextmenu", onContextMenu, { capture: true });
}
